import classnames from 'classnames'
import { toast } from 'react-toastify'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { getProgramEnrollmentsSummary } from '../../../../actions/programActions'
import LeaderboardWidget from './LeaderboardWidget'
import StudentInformationWidget from './StudentInformationWidget'
import BusinessSummaryWidget from './BusinessSummaryWidget'

import classes from './StatsPanel.module.scss'

const StatsPanel = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const { program, enrollmentsSummary } = useSelector(state => state.programDashboard)

  const [isLoadingSummary, setIsLoadingSummary] = useState(true)

  useEffect(() => {
    dispatch(getProgramEnrollmentsSummary(program?.id)).unwrap()
      .then(() => {
        setIsLoadingSummary(false)
      })
      .catch(() => toast.error(t('common.somethingWentWrong'), { position: toast.POSITION.TOP_RIGHT }))
  }, [dispatch, program?.id, t])

  return (
    <div className={classnames('h-100 p-3 d-flex justify-content-center', classes.statsPanel)}>
      <LeaderboardWidget />
      <div className={classnames('pl-4 d-flex flex-column', classes.summarySection)}>
        <BusinessSummaryWidget
          isLoading={isLoadingSummary}
          businessSummary={enrollmentsSummary?.businessSummary}
          packages={enrollmentsSummary?.packages}
        />
        <StudentInformationWidget
          isLoading={isLoadingSummary}
          studentsInfo={enrollmentsSummary?.studentsInfoSummary}
        />
      </div>
    </div>
  )
}

export default StatsPanel
